import { render, staticRenderFns } from "./RareCollapsePaneIcon.vue?vue&type=template&id=54f09042&scoped=true"
import script from "./RareCollapsePaneIcon.vue?vue&type=script&lang=js"
export * from "./RareCollapsePaneIcon.vue?vue&type=script&lang=js"
import style0 from "./RareCollapsePaneIcon.vue?vue&type=style&index=0&id=54f09042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f09042",
  null
  
)

export default component.exports